import { render, staticRenderFns } from "./UcCodesExceptions.vue?vue&type=template&id=47ed6cdf&scoped=true&"
import script from "./UcCodesExceptions.vue?vue&type=script&lang=js&"
export * from "./UcCodesExceptions.vue?vue&type=script&lang=js&"
import style0 from "./UcCodesExceptions.vue?vue&type=style&index=0&id=47ed6cdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed6cdf",
  null
  
)

export default component.exports